import { render, staticRenderFns } from "./cooperateinkage.vue?vue&type=template&id=5f236d32&scoped=true&"
import script from "./cooperateinkage.vue?vue&type=script&lang=js&"
export * from "./cooperateinkage.vue?vue&type=script&lang=js&"
import style0 from "./cooperateinkage.vue?vue&type=style&index=0&id=5f236d32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f236d32",
  null
  
)

export default component.exports